export const DEFAULT_CITY = 'berlin'